import {parseCookies} from 'nookies'
import {useEffect, useState} from 'react'
import {Option} from '../components/Skill/SkillOptions'

export const useOptionCookie = (cookieKey: string, options: Option[], defaultIndex: number) => {
  const [value, setValue] = useState<Option>(options[defaultIndex])

  useEffect(() => {
    const {presentOptions} = parseCookies()
    if (!presentOptions) return

    const value = JSON.parse(presentOptions)?.find((element: any) => {
      return Object.keys(element)[0] === cookieKey
    })
    if (!value) return

    const selected = options.find((item: any) => item.value === value[cookieKey])
    setValue(selected ?? options[defaultIndex])

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return value
}
